/** Sortable, URL-safe ids: a short prefix, a time component and randomness. */
const ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";

export function newId(prefix: string): string {
  const time = Date.now().toString(36).padStart(9, "0");
  const bytes = new Uint8Array(10);
  crypto.getRandomValues(bytes);
  let rand = "";
  for (const b of bytes) rand += ALPHABET[b % 36];
  return `${prefix}_${time}${rand}`;
}

/**
 * Exact lookup key: case, spaces, dashes and dots ignored. Leading zeros are kept because ranches
 * use them on purpose ("042" can be a replacement tag distinct from "42").
 */
export function normalizeTag(tag: string): string {
  return tag.toUpperCase().replace(/[\s\-_.#]/g, "");
}

/** Loose key for candidate matching only; never used to merge identities automatically. */
export function looseTag(tag: string): string {
  const exact = normalizeTag(tag);
  return /^\d+$/.test(exact) ? exact.replace(/^0+(?=\d)/, "") : exact;
}

export const isTempId = (id: string): boolean => id.startsWith("new:");
